export enum TaskCategory {
  DataInput = 'dataInput',
  OptionChoice = 'optionChoice',
  DocumentUpload = 'documentUpload',
  DownloadTemplateSignUpload = 'downloadTemplateSignUpload',
}

export enum TaskType {
  authorizeBooking = 'authorizeBooking',
  provideCustomsWarrantBelgiumFiscal = 'provideCustomsWarrantBelgiumFiscal',
  provideCommercialInvoice = 'provideCommercialInvoice',
  provideSealNumbers = 'provideSealNumbers',
  providePaymentProof = 'providePaymentProof',
  provideBLType = 'provideBLType',
  provideDeliveryDetails = 'provideDeliveryDetails',
  completePackingList = 'completePackingList',
  provideFbaData = 'provideFbaData',
  provideCustomsWarrantGermanyExportPOA = 'provideCustomsWarrantGermanyExportPOA',
  provideConsigneeInformation = 'provideConsigneeInformation',
  provideCustomsWarrantNetherlandsPOA = 'provideCustomsWarrantNetherlandsPOA',
  providePickupDetails = 'providePickupDetails',
  provideCustomsWarrantBelgiumPOA = 'provideCustomsWarrantBelgiumPOA',
  provideSupplierInformation = 'provideSupplierInformation',
  provideIncoTerms = 'provideIncoTerms',
  provideCustomsWarrantGermanySeaPOA = 'provideCustomsWarrantGermanySeaPOA',
  provideCustomsWarrantNetherlandsFiscal = 'provideCustomsWarrantNetherlandsFiscal',
  provideCustomsWarrantGermanyAirPOA = 'provideCustomsWarrantGermanyAirPOA',
  provideCustomsWarrantBelgiumExportPOA = 'provideCustomsWarrantBelgiumExportPOA',
  provideCustomsWarrantNetherlandsExportPOA = 'provideCustomsWarrantNetherlandsExportPOA',
  provideContainerNumbers = 'provideContainerNumbers',
  provideCustomsWarrantSelfCustomsDeclaration = 'provideCustomsWarrantSelfCustomsDeclaration',
  provideCustomsWarrantGermanyAirExportPOA = 'provideCustomsWarrantGermanyAirExportPOA',
  provideMSDS = 'provideMSDS',
  provideIMODeclaration = 'provideIMODeclaration',
}

export const TASK_TYPES = [
  'authorizeBooking', // authorizeBooking
  'completePackingList', // documentUpload
  'provideCommercialInvoice', // documentUpload
  'provideIncoTerms', // optionChoice
  'provideSupplierInformation', // dataInput
  'provideContainerNumbers', // dataInput
  'provideSealNumbers', // dataInput
  'provideBLType', // optionChoice
  'provideConsigneeInformation', // dataInput
  'providePickupDetails', // dataInput
  'provideDeliveryDetails', // dataInput
  'provideFbaData', // dataInput
  'provideCustomsWarrantBelgiumFiscal', // downloadTemplateSignUpload
  'provideCustomsWarrantBelgiumPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantNetherlandsFiscal', // downloadTemplateSignUpload
  'provideCustomsWarrantNetherlandsPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanySeaPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanyAirPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantSelfCustomsDeclaration', // downloadTemplateSignUpload
  'provideCustomsWarrantBelgiumExportPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanyExportPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanyAirExportPOA', // downloadTemplateSignUpload!
  'provideCustomsWarrantNetherlandsExportPOA', // downloadTemplateSignUpload
  'providePaymentProof', // documentUpload
  'provideMSDS', // documentUpload
  'provideIMODeclaration', // documentUpload
] as TaskType[]

export const COMPANY_DOCUMENT_UPLOAD_ACTION_TYPES = [
  'provideCustomsWarrantBelgiumFiscal',
  'provideCustomsWarrantBelgiumPOA',
  'provideCustomsWarrantNetherlandsFiscal',
  'provideCustomsWarrantNetherlandsPOA',
  'provideCustomsWarrantGermanySeaPOA',
  'provideCustomsWarrantGermanyAirPOA',
  'provideCustomsWarrantSelfCustomsDeclaration',
  'provideCustomsWarrantBelgiumExportPOA',
  'provideCustomsWarrantGermanyExportPOA',
  'provideCustomsWarrantGermanyAirExportPOA',
  'provideCustomsWarrantNetherlandsExportPOA',
] as TaskType[]

export const DOCUMENT_UPLOAD_ACTION_TYPES = [
  'completePackingList',
  'provideCommercialInvoice',
  'provideCustomsWarrantBelgiumFiscal',
  'provideCustomsWarrantBelgiumPOA',
  'provideCustomsWarrantNetherlandsFiscal',
  'provideCustomsWarrantNetherlandsPOA',
  'provideCustomsWarrantGermanySeaPOA',
  'provideCustomsWarrantGermanyAirPOA',
  'provideCustomsWarrantSelfCustomsDeclaration',
  'provideCustomsWarrantBelgiumExportPOA',
  'provideCustomsWarrantGermanyExportPOA',
  'provideCustomsWarrantGermanyAirExportPOA',
  'provideCustomsWarrantNetherlandsExportPOA',
  'providePaymentProof',
  'provideMSDS',
  'provideIMODeclaration',
] as const

export type DocumentUploadActions = (typeof DOCUMENT_UPLOAD_ACTION_TYPES)[number]

export enum TASK_STATE {
  PENDING = 'pending',
  AVAILABLE = 'available',
  MANUAL = 'manual',
  COMPLETED = 'completed',
  REMOVED = 'removed',
}

export const taskStateValues = [
  TASK_STATE.AVAILABLE,
  TASK_STATE.COMPLETED,
  TASK_STATE.MANUAL,
  TASK_STATE.REMOVED,
  TASK_STATE.PENDING,
] as const

export type TaskState = (typeof taskStateValues)[number]

export enum CONDITION_STATUS {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export enum AssignableRole {
  ORIGIN_OPERATIONS = 'originOperations',
  DESTINATION_OPERATIONS = 'destinationOperations',
  FINANCIAL_OPERATIONS = 'financialOperations',
  CUSTOMS = 'customs',
  CUSTOMERS_PARTY = 'customersParty',
  CROSS_TRADE_OPERATIONS = 'crossTradeOps',
  UNASSIGNED = 'unassigned',
}

export enum ConfigType {
  IN_LIST = 'inList',
  RELATIVE_DATE = 'relativeDate',
  BOOLEAN = 'boolean',
  NON_EMPTY_LIST = 'nonEmptyList',
  IS_DATE_ACTUAL = 'isDateActual',
  DATA_FIELD = 'dataField',
  TARGET_VALUES = 'targetValues',
}

interface ConditionConfiguration {
  type?: string
  configType?: ConfigType
  selectorFieldPath?: string
  secondaryField?: string
  multiple?: boolean
  eventType?: string
  value?: unknown
  referenceLabel?: string
  conditionStatus?: CONDITION_STATUS
}

interface TaskUser {
  id: string
  name: string
}

interface TaskSystem {
  createdBy: TaskUser
  updatedBy: TaskUser
  createdAt: Date
  updatedAt: Date
}

interface TaskAssignee {
  userID: string
  fullName: string
  email: string
  initials: string
  role: AssignableRole
}

interface TaskTimestamp {
  startDate: Date | null
  dueDate: Date | null
  completedAt: Date | null
}

interface TaskDefinitionAttributes {
  id: string | null
  name: string
  taskModuleID: string | null
  role: AssignableRole
  description: string
  i18nTerm?: string
  deepLinkType?: string
  deepLinkTarget?: string
  isRepeatable?: boolean
  category?: TaskCategory | null
  type?: TaskType | null
}

export interface Task {
  id?: string
  notes?: string
  taskDefinitionAttributes: TaskDefinitionAttributes
  timestamps: TaskTimestamp
  state: TaskState
  sequenceNumber: number
  assignee: TaskAssignee
  lastTouchedByUser?: TaskUser
  isIrrelevant: boolean
  isManualDueDate?: boolean
  system?: TaskSystem
  filterConditions?: Omit<ConditionConfiguration, 'referenceLabel'>[]
  startConditions?: ConditionConfiguration[]
  dueConditions?: ConditionConfiguration[]
  completionConditions?: ConditionConfiguration[]
  isDueDateChangeable: boolean
}
